import React from 'react';
import { useLicencia } from '../context/LicenciaContext';

export default function ModalLicencia() {
    const { estado, diasGracia, mensaje, mostrarModal, cerrarModal } = useLicencia();

    // BLOQUEO lo maneja PantallaBloqueo como overlay; acá solo WARNING
    if (!mostrarModal || !estado || estado !== 'WARNING') return null;

    const dias = diasGracia;

    return (
        <div
            style={{
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 99998,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)'
            }}
            onClick={cerrarModal}
        >
            <div
                style={{
                    backgroundColor: 'white', borderRadius: '24px', padding: '40px',
                    maxWidth: '420px', width: '90%', textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                }}
                onClick={e => e.stopPropagation()}
            >
                {/* Contador de días */}
                <div style={{
                    width: '80px', height: '80px', borderRadius: '50%',
                    backgroundColor: '#fffbeb', border: '3px solid #f59e0b',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 20px'
                }}>
                    <span style={{ fontSize: '28px', fontWeight: 900, color: '#f59e0b', lineHeight: 1 }}>
                        {dias}
                    </span>
                    <span style={{ fontSize: '10px', color: '#f59e0b', fontWeight: 700, marginTop: '2px' }}>
                        {dias === 1 ? 'DÍA' : 'DÍAS'}
                    </span>
                </div>

                <h2 style={{ fontWeight: 800, fontSize: '1.4rem', margin: '0 0 10px', color: '#92400e' }}>
                    Pago pendiente
                </h2>

                <div style={{
                    padding: '12px 18px', marginBottom: '22px',
                    backgroundColor: '#fffbeb', borderRadius: '12px',
                    border: '1px solid #fde68a'
                }}>
                    <p style={{ color: '#b45309', fontSize: '14px', margin: 0, lineHeight: 1.6 }}>
                        {mensaje || `Te quedan ${dias} días para regularizar el pago antes de que el sistema se bloquee.`}
                    </p>
                </div>

                {dias === 0 && (
                    <p style={{ fontSize: '12px', color: '#ef4444', marginBottom: '16px', fontWeight: 600 }}>
                        ⚠️ Último día de gracia — el sistema se bloqueará mañana.
                    </p>
                )}

                <button
                    onClick={cerrarModal}
                    style={{
                        width: '100%', padding: '14px',
                        background: '#f59e0b', color: '#fff',
                        border: 'none', borderRadius: '14px',
                        fontSize: '1rem', fontWeight: 700, cursor: 'pointer'
                    }}
                >
                    ENTENDIDO
                </button>

                <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '14px', marginBottom: 0 }}>
                    Contacta a soporte: soporte@komity.cl
                </p>
            </div>
        </div>
    );
}
